import script from "./Tab.vue?vue&type=script&setup=true&lang=ts"
export * from "./Tab.vue?vue&type=script&setup=true&lang=ts"

import "./Tab.vue?vue&type=style&index=0&id=a3db716a&lang=less&scoped=true"

import exportComponent from "/Users/nikkizeng/Desktop/running/ph-miao-wechat/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3db716a"]])

export default __exports__